/* This require needs to be relative to the root folder since this file gets copied over to environment.js on deploy */
const config = require('./node_modules/@adparlor-devops/js-anvil/lib/config/index.js');

module.exports = config.endpoints.production;



//////////////////
// WEBPACK FOOTER
// ./environment.js
// module id = 2
// module chunks = 0